import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { LanguageService } from '../../../../framework/services/language.service'
import { EditEngagementMemoryServiceService } from '../../edit-engagement-memory-service/edit-engagement-memory-service.service';

@Component({
  selector: 'app-edit-language',
  templateUrl: './edit-language.component.html',
  styleUrls: ['./edit-language.component.css']
})
export class EditLanguageComponent implements OnInit {

  languageList = [];
  selectedLanguages: any[] = [];
  languageControl: FormControl;
  @Output() showNextControl = new EventEmitter<string>()

  constructor(private languageService: LanguageService,
    private engagementMemoryService: EditEngagementMemoryServiceService) {
    this.languageControl = new FormControl(this.selectedLanguages, this.languageRequired());
    
  }

  ngOnInit() {
    this.languageList = this.engagementMemoryService.getLanguages();    
    // if (this.selectedLanguages.length == 0 && this.engagementMemoryService.getEngagementId() > 0) {
    //   this.languageService.getEngagementSelectedLanguages(this.engagementMemoryService.getEngagementId()).subscribe((response) => {
    //     if (response.data && response.data.length > 0) {
    //       this.selectedLanguages = response.data.filter(t => t.isAppLanguage);
    //     }
    //   })
    // } else {
      this.selectedLanguages = this.engagementMemoryService.getSelectedLanguages();
    // }
  }


  resetLanguageRoles(isEnglishSelected: boolean) {
    let eyRoles = this.engagementMemoryService.getLanguageBasedRoles();
    if (eyRoles && eyRoles.length > 0) {
      let roles = isEnglishSelected ? eyRoles.find(t => t.languageName == "English")?.engagementRoleModels : eyRoles.find(t => t.languageName == "French")?.engagementRoleModels;
      eyRoles.forEach(element => {
        if (element.engagementRoleModels == null || element.engagementRoleModels.length == 0) {
          element.engagementRoleModels = roles
        }
      })
    }
  }

  onNextButtonClicked() {
    if (!this.languageControl.invalid) {
      this.engagementMemoryService.setSelectedLanguages(this.selectedLanguages);
      this.showNextControl.emit("basicDetails");
    } else {
      this.languageControl.markAsTouched();
    }
  }

  languageRequired(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched && control.value) {
        if (control.value.length > 0) {
          return null;
        }
      } else if (control.value && control.value.length > 0) {
        return null;
      }
      return { 'languageRequired': 'Language is required' };
    }
  }

}
